"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _format = require("@/utils/format");
var _date = require("@/utils/date");
var storeApi = _interopRequireWildcard(require("@/api/store"));
var _url = require("@/utils/url");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ["store"],
  data: function data() {
    return {
      tableData: [],
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      loading: false
    };
  },
  methods: {
    formatDateTime: function formatDateTime(n) {
      return (0, _date.formatDateTime)(n);
    },
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    fetchTableData: function () {
      var _fetchTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return storeApi.requestStore(this.store.id);
            case 2:
              res = _context.sent;
              this.tableData = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchTableData() {
        return _fetchTableData.apply(this, arguments);
      }
      return fetchTableData;
    }(),
    handleApprove: function handleApprove(row) {
      var _this = this;
      this.loading = true;
      storeApi.approve(this.store.id, row.id).then(function () {
        _this.fetchTableData();
        _this.$notify({
          type: "success",
          message: "Thành công",
          title: "Thông báo"
        });
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  watch: {
    store: {
      handler: function handler() {
        this.fetchTableData();
      },
      deep: true
    }
  }
};